(function () {
  'use strict';
  if (customElements.get('sk-tray-builder')) return;
  const NS = 'http://www.w3.org/2000/svg';
  class SKTrayBuilder extends HTMLElement {
    connectedCallback() {
      if (this.controller || !window.SKTrayGeometry) return;
      this.controller = new AbortController();
      this.api = window.SKTrayGeometry;
      this.form = this.querySelector('.sk-tray__form');
      this.inputs = ['width','depth','height'].map((name) => this.form.elements.namedItem(name));
      this.svg = this.querySelector('[data-tray-svg]');
      this.faces = this.querySelector('[data-tray-faces]');
      this.status = this.querySelector('[data-tray-status]');
      this.error = this.querySelector('[data-tray-error]');
      this.download = this.querySelector('[data-tray-download]');
      this.prepare = this.querySelector('[data-tray-prepare]');
      this.angle = this.querySelector('[name="angle"]');
      this.yaw = -35; this.tilt = 0.64;
      const on = (target, event, fn) => target.addEventListener(event, fn, {signal: this.controller.signal});
      on(this.form, 'submit', (event) => { event.preventDefault(); this.save(); });
      on(this.form, 'input', () => { this.update(); });
      on(this.angle, 'input', () => { this.yaw = Number(this.angle.value); this.render(); });
      on(this.querySelector('[data-tray-reset]'), 'click', () => {
        this.inputs.forEach((input, i) => { input.value = [180,120,35][i]; });
        this.yaw = -35; this.tilt = 0.64; this.angle.value = '-35'; this.update();
      });
      this.querySelectorAll('[data-tray-preset]').forEach((button) => on(button, 'click', () => {
        button.dataset.trayPreset.split(',').forEach((value, i) => { this.inputs[i].value = value; });
        this.update();
      }));
      this.querySelectorAll('[data-tray-view]').forEach((button) => on(button, 'click', () => {
        this.tilt = button.dataset.trayView === 'top' ? Math.PI / 2 : 0.64;
        this.render();
      }));
      on(this.prepare, 'click', () => {
        if (!this.mesh) return;
        const panel = this.querySelector('[data-tray-next]'); panel.hidden = false;
        panel.querySelector('h2').focus();
        panel.scrollIntoView({block: 'start', behavior: 'auto'});
      });
      on(this.svg, 'pointerdown', (event) => {
        if (!this.mesh || (event.pointerType === 'mouse' && event.button !== 0)) return;
        this.drag = {x: event.clientX, yaw: this.yaw, id: event.pointerId};
        this.svg.setPointerCapture(event.pointerId);
      });
      on(this.svg, 'pointermove', (event) => {
        if (!this.drag || event.pointerId !== this.drag.id) return;
        this.yaw = ((this.drag.yaw + (event.clientX - this.drag.x) * 0.5 + 540) % 360) - 180;
        this.angle.value = String(Math.round(this.yaw)); this.render();
      });
      ['pointerup','pointercancel','lostpointercapture'].forEach((type) => on(this.svg, type, () => { this.drag = null; }));
      this.querySelector('[data-tray-js-notice]').hidden = true;
      const query=new URLSearchParams(location.search);
      if(query.has('generator_version')) {
        const values=['width','depth','height'].map(k=>Number(query.get(k)));
        if(query.get('generator')==='tray'&&query.get('generator_version')==='1'&&this.api.validate(...values))this.inputs.forEach((input,i)=>{input.value=String(values[i]);});
        else {this.inputs.forEach(input=>{input.value='';});this.importError='保存した生成器の版・寸法を読み込めません。対応する記録を確認してください。';}
      }
      const recordButton=this.querySelector('[data-tray-record]');
      if(recordButton)on(recordButton,'click',()=>this.saveRecord());
      this.update();
      if(this.importError)this.status.textContent=this.importError;
    }
    saveRecord(){
      this.update();if(!this.mesh)return;
      const record={schema:'sk-maker/v1',kind:'design',generator:'tray',generatorVersion:1,parameters:{width:this.mesh.width,depth:this.mesh.depth,height:this.mesh.height,wall:2,bottom:2}};
      try{window.SKMaker.download('sk-tray-design.json',JSON.stringify(record,null,2));const saved=window.SKMaker.write('last-design',record);this.status.textContent='制作記録の保存を開始しました。会員ホームの制作ノートで読み込めます。'+(saved?'':'端末内の一時保存は利用できません。');}catch{this.status.textContent='制作記録を保存できませんでした。もう一度お試しください。';}
    }
    disconnectedCallback() {
      this.controller?.abort(); this.controller = null; this.drag = null;
    }
    update() {
      const values = this.inputs.map((input) => input.value.trim() === '' ? NaN : Number(input.value));
      const valid = this.api.validate(...values);
      const labels = ['幅','奥行','高さ'];
      const limits = [[20,300],[20,300],[8,150]];
      const errors = [];
      this.inputs.forEach((input, i) => {
        const invalid = !Number.isInteger(values[i]) || values[i] < limits[i][0] || values[i] > limits[i][1];
        input.setAttribute('aria-invalid', String(invalid));
        if (invalid) errors.push(`${labels[i]}は${limits[i][0]}〜${limits[i][1]} mmの整数で入力してください。`);
      });
      this.error.textContent = errors.join(' '); this.error.hidden = valid;
      this.download.disabled = !valid; this.prepare.disabled = !valid;
      const recordButton=this.querySelector('[data-tray-record]');if(recordButton)recordButton.disabled=!valid;
      this.querySelector('[data-tray-next]').hidden = true;
      this.status.textContent = '';
      this.querySelectorAll('[data-tray-preset]').forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.trayPreset === values.join(',')));
      });
      if (!valid) {
        this.mesh = null; this.faces.replaceChildren();
        this.querySelector('[data-tray-dimensions]').textContent = '寸法を入力すると形が表示されます';
        this.querySelector('[data-tray-inner]').textContent = '—';
        this.svg.setAttribute('aria-label', '寸法を修正するとプレビューを再表示します');
        return;
      }
      this.mesh = this.api.create(...values);
      const [w,d,h] = values;
      this.querySelector('[data-tray-dimensions]').textContent = `${w} × ${d} × ${h} mm`;
      this.querySelector('[data-tray-inner]').textContent = `${w-4} × ${d-4} × ${h-2} mm`;
      this.querySelector('[data-tray-final-size]').textContent = `${w} × ${d} × ${h} mm`;
      this.svg.setAttribute('aria-label', `幅${w}、奥行${d}、高さ${h}ミリの収納トレー。壁と底は2ミリ。`);
      this.render();
    }
    render() {
      if (!this.mesh) return;
      const mesh = this.mesh, yaw = this.yaw * Math.PI / 180, tilt = this.tilt;
      const rotate = ([x,y,z]) => {
        x -= mesh.width/2; y -= mesh.depth/2; z -= mesh.height/2;
        const rx = x*Math.cos(yaw)-y*Math.sin(yaw), ry = x*Math.sin(yaw)+y*Math.cos(yaw);
        return [rx, ry*Math.sin(tilt)-z*Math.cos(tilt), ry*Math.cos(tilt)+z*Math.sin(tilt)];
      };
      const projected = mesh.triangles.map((t) => t.map(rotate));
      const points = projected.flat(), xs = points.map((p) => p[0]), ys = points.map((p) => p[1]);
      const xmin = Math.min(...xs), xmax = Math.max(...xs), ymin = Math.min(...ys), ymax = Math.max(...ys);
      const scale = Math.min(470/(xmax-xmin), 290/(ymax-ymin));
      const cx = (xmin+xmax)/2, cy = (ymin+ymax)/2;
      const faces = projected.map((triangle, i) => {
        const source = mesh.triangles[i], normal = this.api.normal(source);
        // A triangle's centre can be behind the floor even when its near edge covers it.
        // For this open rectangular tray, paint the floor, inner walls, rim, then outer walls.
        const outer = source.every(p => p[0] === 0) || source.every(p => p[0] === mesh.width) ||
          source.every(p => p[1] === 0) || source.every(p => p[1] === mesh.depth);
        const layer = normal[2] > 0 ? (source[0][2] === mesh.height ? 2 : 0) : (outer ? 3 : 1);
        return {triangle, source, layer, depth: triangle.reduce((a,p) => a+p[2],0)/3};
      });
      faces.sort((a,b) => a.layer-b.layer || a.depth-b.depth);
      const fragment = document.createDocumentFragment();
      for (const {triangle, source} of faces) {
        const n = this.api.normal(source);
        const facing = (n[0]*Math.sin(yaw)+n[1]*Math.cos(yaw))*Math.cos(tilt)+n[2]*Math.sin(tilt);
        if (facing < 0.00001) continue;
        const polygon = document.createElementNS(NS, 'polygon');
        polygon.setAttribute('points', triangle.map((p) => `${(300+(p[0]-cx)*scale).toFixed(2)},${(195+(p[1]-cy)*scale).toFixed(2)}`).join(' '));
        const light = 55 + 18 * n[2] - 9 * n[0] - 5 * n[1];
        const color = `hsl(211 35% ${light}%)`;
        polygon.setAttribute('fill', color); polygon.setAttribute('stroke', color); polygon.setAttribute('stroke-width', '0.7');
        fragment.append(polygon);
      }
      this.faces.replaceChildren(fragment);
      this.querySelectorAll('[data-tray-view]').forEach((button) => {
        button.setAttribute('aria-pressed', String((button.dataset.trayView === 'top') === (tilt === Math.PI/2)));
      });
    }
    save() {
      this.update();
      if (!this.mesh) { this.inputs.find((input) => input.getAttribute('aria-invalid') === 'true')?.focus(); return; }
      const mesh = this.mesh;
      let url;
      try {
        url = URL.createObjectURL(new Blob([this.api.toSTL(mesh)], {type: 'application/octet-stream'}));
        const link = document.createElement('a');
        link.href = url; link.download = `sk-tray-v1-${mesh.width}x${mesh.depth}x${mesh.height}mm.stl`;
        this.append(link); link.click(); link.remove();
        this.status.textContent = 'STLの保存を開始しました。スライサーで単位をmmにし、寸法を確認してください。';
      } catch (_error) {
        this.status.textContent = '保存できませんでした。別のブラウザで再度お試しください。';
      } finally {
        if (url) setTimeout(() => URL.revokeObjectURL(url), 60000);
      }
    }
  }
  customElements.define('sk-tray-builder', SKTrayBuilder);
})();
